import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.benutzer-entra-id-koppeln-admin';
import * as api from '../../../clients/benutzerverwaltung';

@Injectable()
export class BenutzerverwaltungBenutzerEntraIdKoppelnAdminEffects {

    BenutzerEntraIdKoppelnAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_BENUTZER_ENTRA_ID_KOPPELN_ADMIN),
        mergeMap((x: ac.PostBenutzerEntraIdKoppelnAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postBenutzerEntraIdKoppelnAdmin(x.benutzerRequest).pipe(
                map((result: any) => {
                    return new ac.PostBenutzerEntraIdKoppelnAdminErfolgreichAction(result, x.benutzerRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostBenutzerEntraIdKoppelnAdminFehlerAction(error, x.benutzerRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.BenutzerverwaltungAdminCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.BenutzerverwaltungAdminCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.BenutzerverwaltungAdminCommandService);
        }
        return this.service;
    }
}
